import Cookies from 'universal-cookie';

export default {
    methods: {
        parsePotentiallyGroupedFloat(stringValue) {
            if (!stringValue || typeof stringValue === 'number') {
                return stringValue;
            }
            stringValue = stringValue.trim();
            let result = stringValue.replace(/[^0-9]/g, '');
            if (/[,.]\d{2}$/.test(stringValue)) {
                result = result.replace(/(\d{2})$/, '.$1');
            }
            return parseFloat(result);
        },

        async trackTransaction(orderDetails) {
            const orderId = Date.now().toString();

            const unitPrice = orderDetails.net ? this.parsePotentiallyGroupedFloat(orderDetails.net) / orderDetails.quantity : null;

            if (orderDetails) {
                const eventData = {
                    email: orderDetails.customer?.email || null,
                    phone_number: orderDetails.customer?.phone || null,
                    first_name: orderDetails.customer?.firstName || null,
                    last_name: orderDetails.customer?.lastName || null,
                    home_address: [
                        {
                            street: orderDetails.customer?.address || null,
                            city: orderDetails.customer?.city || null,
                            region: orderDetails.customer?.state || null,
                            postal_code: orderDetails.customer?.zipcode || null,
                            country: orderDetails.customer?.country || null,
                        }
                    ],
                    ecommerce: {
                        transaction_id: orderId,
                        value: orderDetails.net ? this.parsePotentiallyGroupedFloat(orderDetails.net) : null,
                        tax: orderDetails.vatAmount ? this.parsePotentiallyGroupedFloat(orderDetails.vatAmount) : null,
                        currency: orderDetails.currency || null,
                        items: [
                            {
                                item_name: orderDetails.title || null,
                                item_id: orderDetails.id || null,
                                price: unitPrice || null,
                                item_category: orderDetails.trainers || null,
                                item_category2: orderDetails.start || null,
                                item_category3: orderDetails.paymentMethod || null,
                                quantity: orderDetails.quantity || null
                            }
                        ]
                    }
                };

                this.$gtm.push({
                    event: 'purchase',
                    ...eventData
                });

                const cookies = new Cookies();

                let startDate = orderDetails?.startDate;
                if (startDate) {
                    const date = new Date(startDate);

                    // Manually build ISO 8601 format
                    const year = date.getUTCFullYear();
                    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
                    const day = String(date.getUTCDate()).padStart(2, '0');
                    // const time = date.toISOString().split('T')[1]; // HH:mm:ss.sssZ

                    startDate = `${year}-${month}-${day}`;
                }

                // hutk, pageUrl, pageName are optional within payload.
                const eventPayload = {
                    email: eventData.email,
                    firstname: eventData.first_name,
                    lastname: eventData.last_name,
                    phone: eventData.phone_number,
                    jobtitle: orderDetails?.customer?.jobTitle || '',
                    company: orderDetails?.customer?.company || '',

                    billing_city: eventData.home_address[0]?.city,
                    billing_state: eventData.home_address[0]?.region,
                    billing_country: eventData.home_address[0]?.country,
                    billing_address_line_1: eventData.home_address[0]?.street,
                    vat_number: orderDetails?.customer?.vatNumber || '',
                    booking_number: orderId,
                    billing_contact: orderDetails?.customer?.type !== 'corporate',

                    course_id: orderDetails?.id || '',
                    course_name: orderDetails?.title || '',
                    course___city: orderDetails?.location || 'Virtual',
                    course___startdate__dmy_: startDate,

                    hs_context: {
                        hutk: cookies.get('hubspotutk') || '',
                        ipAddress: cookies.get('ipAddress') || '',
                        pageName: document.title,
                        pageUrl: orderDetails?.url || window.location.href,
                    },

                    ipAddress: cookies.get('ipAddress') || '',
                    redirectUrl: '',
                    sfdcCampaignId: '',
                };

                try {
                    const response = await fetch('/api/hubspot', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(eventPayload),
                    });

                    if (!response.ok) {
                        throw new Error(
                            `Error sending event: ${response.statusText}`
                        );
                    }
                } catch (error) {
                    // silently fail
                }
            }
        },
    }
};
